import { useEffect, useState } from "react";
import LoginImage from "../../../../../media/images/LoginImage.png";
import CustomButton from "../../../../components/CustomButton";
import LoginIcon from "../../../../../media/images/icons/login";
import ArrowLeft from "../../../../../media/images/icons/arrow-left";
import CustomInput from "../../../../components/CustomInput";
import { Link, useNavigate } from "react-router-dom";
import { Grid, Box, Typography, InputLabel, useTheme } from "@mui/material";
import LogoImage from "../../../../../media/images/icons/logo.svg";

import { useAppDispatch, useAppSelector } from "../../../../../hooks/useRedux";
import { useFormik } from "formik";
import MobileHeader from "../../../../layout/AuthLayout/MobileHeader";
import RegisterLink from "../RegisterLink";
import { loginValidator } from "../../../../../formValidators/auth/loginFormVlidators";
import AuthFooter from "../../../../layout/AuthLayout/Footer";
import { grey } from "@mui/material/colors";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../../services/fetcher";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../redux/features/snackbarSlice";
import ArrowTickLeft from "../../../../../media/images/icons/arrow-tick-left";
import CustomPasswordInput from "../../../../components/CustomPasswordInput";
import ChannelLinks from "../../../../components/ChannelLinks";

export default function UserGridNew() {
  const theme = useTheme();
  const [token, setToken] = useState("");

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const userLoginTab = useAppSelector((state) => state.settings.userLoginTab);
  const isDriver = userLoginTab === "drivers";
  const roleTitle = isDriver ? "ورود راننده" : "ورود صاحب کالا";
  const {
    trigger: getUserInfoTrigger,
    isMutating: getUserInfoTriggerMutating,
  } = useSWRMutation([`/User/GetUserInfo`, token], fetcherPost, {
    onSuccess: async (data) => {
      const { role } = data;

      if (role === 21 && userLoginTab === "drivers") {
        dispatch(setOpenSnackbar(true));
        dispatch(setSnackbarErrorStatus(400));
        dispatch(setSnackbarDescription("نام کاربری یا رمز اشتباه است."));
        return;
      }
      if (role === 12 && userLoginTab === "burdenOwner") {
        dispatch(setOpenSnackbar(true));
        dispatch(setSnackbarErrorStatus(400));
        dispatch(setSnackbarDescription("نام کاربری یا رمز اشتباه است."));
        return;
      }

      localStorage.setItem("access_token", token);
      if (role === 21) return navigate("/owner/dashboard", { replace: true });
      if (role === 12) return navigate("/driver/dashboard", { replace: true });
    },
  });

  const { trigger: loginTrigger, isMutating: loginMutating } = useSWRMutation(
    [`/Account/Login`],
    fetcherPost,
    {
      onSuccess: (data) => {
        const { access_token } = data;
        setToken(access_token);

        setTimeout(() => {
          getUserInfoTrigger();
        }, 500);
      },
      onError: (e) => {
        dispatch(setOpenSnackbar(true));
        dispatch(setSnackbarErrorStatus(e.response?.data?.errorCode));
        dispatch(setSnackbarDescription(e.response?.data?.error));
      },
    }
  );

  const formik = useFormik({
    initialValues: {
      userName: "",
      password: "",
    },
    validationSchema: loginValidator,
    onSubmit: (values) => {
      loginTrigger(values);
    },
  });

  useEffect(() => {
    formik.resetForm();
  }, [userLoginTab]);

  useEffect(() => {
    const handleKeyPress = (event: any) => {
      if (event.key === "Enter") {
        formik.handleSubmit();
      }
    };

    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  return (
    <>
      <MobileHeader>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            onClick={() => navigate("/")}
            noWrap
            sx={{
              cursor: "pointer",
              color: "secondary.main",
              fontWeight: 700,
              fontSize: "14px",
            }}
          >
            کارن ترابر نت
          </Typography>
          <ArrowTickLeft color={theme.palette.textColor.main} size={14} />
          <Typography
            noWrap
            sx={{
              color: "secondary.main",
              fontSize: "12px",
              fontWeight: 700,
            }}
          >
            {roleTitle}
          </Typography>
        </Box>
      </MobileHeader>

      <Box
        sx={{
          flex: 1,
          // overflow: "hidden",
        }}
      >
        <Grid
          container
          sx={{
            height: "100%",
            // overflow: "hidden",
          }}
        >
          <Grid
            item
            xs
            sm
            md={12}
            lg={12}
            sx={{
              height: "100%",
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
              paddingTop: "12px",
              alignItems: "center",
              paddingX: {
                xs: "8px",
              },
            }}
          >
            <Box
              sx={{
                width: "100%",
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  marginX: "auto",
                  width: {
                    // xl: "40%",
                    // lg: "60%",
                    // md: "80%",
                    xs: "100%",
                  },
                }}
              >
                <Box
                  sx={{
                    mb: "16px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: {
                      xs: "flex",
                      md: "none",
                    },
                  }}
                >
                  <Typography
                    noWrap
                    sx={{
                      fontWeight: 700,
                      fontSize: "15px",
                    }}
                    color={"primary.main"}
                  >
                    {roleTitle}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    backgroundColor: "bgColor.white",
                    justifySelf: "center",
                    boxShadow: "0px 4px 15px 3px rgba(0,0,0,0.1)",
                    paddingX: "10px",
                    paddingY: "16px",
                    borderRadius: "16px",
                    marginX: "auto",
                  }}
                >
                  <Box
                    sx={{
                      mt: "16px",
                      paddingX: "8px",
                    }}
                  >
                    <InputLabel
                      sx={{
                        color: "primary.main",
                        fontWeight: 700,
                        marginBottom: "8px",
                      }}
                      htmlFor="outlined-adornment-amount"
                    >
                      {userLoginTab === "burdenOwner"
                        ? "نام کاربری صاحب کالا:"
                        : "نام کاربری راننده: "}
                    </InputLabel>

                    <CustomInput
                      type={"numeric"}
                      errorMessage={
                        formik.touched.userName && formik.errors.userName
                      }
                      error={
                        formik.touched.userName &&
                        Boolean(formik.errors.userName)
                      }
                      name="userName"
                      handelChange={formik.handleChange}
                      value={formik.values.userName}
                    />
                  </Box>

                  <Box
                    sx={{
                      mt: "8px",
                      paddingX: "8px",
                    }}
                  >
                    <InputLabel
                      sx={{
                        color: "primary.main",
                        fontWeight: 700,
                        marginBottom: "8px",
                      }}
                      htmlFor="outlined-adornment-amount"
                    >
                      رمز عبور:
                    </InputLabel>

                    <CustomPasswordInput
                      placHolder="رمز عبور خود را وارد کنید..."
                      errorMessage={
                        formik.touched.password && formik.errors.password
                      }
                      error={
                        formik.touched.password &&
                        Boolean(formik.errors.password)
                      }
                      name="password"
                      handelChange={formik.handleChange}
                      value={formik.values.password}
                    />
                    {/* <MathCaptcha
                      lightColor={theme.palette.primary[50]}
                      mainColor={theme.palette.primary.main}
                    /> */}
                  </Box>

                  <CustomButton
                    loading={loginMutating || getUserInfoTriggerMutating}
                    onClick={formik.handleSubmit}
                    flexDirection="row"
                    title="ورود"
                    justifyContent="center"
                    bgColor="primary.main"
                    width="100%"
                    fSize="16px"
                    fWeight="700"
                    px="10px"
                    py="10px"
                    borderRadius="10px"
                    textColor="lightStatic.main"
                    icon2={<LoginIcon size={32} />}
                    mt="16px"
                  />

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "16px",
                    }}
                  >
                    <Typography
                      sx={{
                        flex: "1",
                        fontSize: "14px",
                      }}
                    >
                      رمز عبور خود را فراموش کرده‌اید؟
                    </Typography>
                    <Link
                      to={"/forget-password"}
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          backgroundColor: "#FFD54F",
                          padding: "8px",
                          borderRadius: "8px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "13px",
                            color: grey[800],
                            fontWeight: "600",
                          }}
                        >
                          فراموشی رمز عبور
                        </Typography>
                        <ArrowLeft color={grey[800]} />
                      </Box>
                    </Link>
                  </Box>
                </Box>

                <RegisterLink />
                <ChannelLinks />
              </Box>
            </Box>
            {/* <AuthFooter /> */}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            sx={{
              height: "100%",
              backgroundImage: `url(${LoginImage})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "20%",
              display: {
                xs: "none",
                sm: "none",
                md: "none",
                lg: "none",
              },

              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: "100%",
                textAlign: "center",
                paddingY: "16px",
                paddingX: "10px",
                position: "relative",
                maxWidth: {
                  xl: "45%",
                  lg: "65%",
                  md: "80%",
                },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  backgroundColor: "background.default",
                  opacity: "0.9",
                  borderRadius: "16px",
                }}
              ></Box>
              <Box
                sx={{
                  position: "relative",
                }}
              >
                <img width={70} src={LogoImage} alt="" />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <AuthFooter />
    </>
  );
}
